import React, {useState} from 'react';
import OldUrls from '../../../models/utils/OldUrls';
import UILink from '../../../ui/UILink';
import {EventInvoice} from '../UnpaidInvoices';
import Tooltip from '../../../ui/Tooltip';
import IconError from '../../icon/IconError';
import {showError} from '../../../ui/ToastNotification';
import {loadStripe} from '@stripe/stripe-js';
import cn from 'classnames';
import SecondaryButton from '../../../ui/SecondaryButton';

type Props = {
  invoice: EventInvoice
  stripePublicKey: string
}

export default function InvoiceRow({invoice, stripePublicKey}: Props) {
  const [promise] = useState(loadStripe(stripePublicKey, {stripeAccount: invoice.clientStripeId}))
  const [loading, setLoading] = useState(false)

  const almostOverdue = invoice.daysOverdue >= 15 && invoice.daysOverdue < 45;
  const overdue = invoice.daysOverdue >= 45;


  const handleClick = async () => {
    setLoading(true);
    const stripe = await promise;
    const response = await fetch(OldUrls.startSession(invoice.eventId, true), {method: 'POST'});
    const session = await response.json();
    const result = await stripe?.redirectToCheckout({
      sessionId: session.id,
    }).finally(() => setLoading(false));

    if (result?.error) {
      showError(result?.error.message);
    }
  };

  return (
    <>
      <div className="col-span-8">
        {overdue &&
        <>
          <Tooltip content="Coordinators may put restrictions on your account until you pay the invoice"
            label="test"><IconError className="text-red"/> </Tooltip>
          <span className="text-red">Overdue</span> <span className="text-gray-dark">&#8226;</span>
        </>
        }
        {almostOverdue &&
        <>
          <span
            className="text-yellow">{invoice.daysOverdue === 44 ? "Overdue in 1 day" : `Overdue in ${45 - invoice.daysOverdue} days`}
          </span> <span className="text-gray-dark">&#8226;</span>
        </>
        } <UILink href={OldUrls.event(parseInt(invoice.eventId, 10))}>{invoice.title}</UILink>
      </div>
      <div className="col-span-4">
        <div className="grid grid-cols-2">
          <div>{invoice.sentDate}</div>
          <div className={cn({'text-right': !invoice.payable, 'text-center': invoice.payable})}>
            {invoice.payable &&
            <SecondaryButton onClick={handleClick} loading={loading} short={true} className="-mt-1 ml-3 whitespace-nowrap"
              narrow={true}>Pay&nbsp;{invoice.amount}</SecondaryButton>
            }
            {!invoice.payable && invoice.amount}
          </div>
        </div>
      </div>
    </>
  );
}
